// extracted by mini-css-extract-plugin
export default {"loading":"style_loading__+tr7S","spinner":"style_spinner__1Gkhi"};